type Scenario = {
  title: string;
  district: string;
  text: string;
};

const scenarios: Scenario[] = [
  {
    title: 'Panne am Morgen',
    district: 'Berlin-Mitte',
    text: 'Liegenbleiber, Startproblem oder kurzfristiger Transport zur Werkstatt mit klarer Telefonabsprache.'
  },
  {
    title: 'Unfall auf der Stadtautobahn',
    district: 'A100 / Berlin',
    text: 'Bergung nach Unfall inklusive Absicherung der Stelle und abgestimmtem Abtransport.'
  },
  {
    title: 'Blockierte Einfahrt',
    district: 'Neukölln',
    text: 'Privatgrund, Hof oder Zufahrt: Dokumentation, saubere Beauftragung und direkte Entfernung.'
  },
  {
    title: 'Nachteinsatz',
    district: 'Kreuzberg',
    text: 'Aufträge außerhalb der Stoßzeiten mit Fokus auf Ruhe, Erreichbarkeit und schneller Orientierung.'
  },
  {
    title: 'Tiefgarage oder Hof',
    district: 'Pankow',
    text: 'Enge Zufahrten oder schwierige Stellplätze, bei denen vorab klar geprüft wird, ob der Einsatz passt.'
  },
  {
    title: 'Motorradtransport',
    district: 'Charlottenburg',
    text: 'Zweiradtransport nach Panne oder Schaden mit sicherer Verladung und abgestimmtem Zielort.'
  }
];

export default function TestimonialsSection() {
  return (
    <section aria-labelledby="testimonials-heading" className="bg-[#111827] py-16 text-white">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <p className="text-sm font-semibold text-amber-100">Einsatzszenarien</p>
          <h2 id="testimonials-heading" className="mt-3 text-3xl font-semibold leading-tight sm:text-4xl">
            Typische Fälle aus dem Berliner Alltag.
          </h2>
          <p className="mt-4 text-base leading-8 text-slate-300">
            Das sind keine Bewertungen, sondern realistische Einsatzbilder. Sie zeigen, welche Fälle Schiek strukturiert abdeckt.
          </p>
        </div>

        <div className="mt-10 grid gap-4 md:grid-cols-2 xl:grid-cols-3">
          {scenarios.map((scenario) => (
            <article
              key={`${scenario.title}-${scenario.district}`}
              className="flex h-full flex-col rounded-[1.5rem] border border-white/10 bg-white/5 p-5 shadow-[0_18px_40px_rgba(0,0,0,0.22)]"
            >
              <p className="text-sm font-semibold text-amber-100">{scenario.district}</p>
              <h3 className="mt-2 text-lg font-semibold text-white">{scenario.title}</h3>
              <p className="mt-4 text-sm leading-7 text-slate-300">{scenario.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
